import { createDetailDialog } from 'dialogs/common'
import { dialogSizes } from 'dialogs'
import Form from 'pages/flavourCharacteristicses/form'
import { api, actionCreators } from 'store/modules/flavourCharacteristicses'

const metadata = {
  icon: 'lemon-o',
  page: 'flavourCharacteristicses',
  dialogSize: dialogSizes.MD
}

export default createDetailDialog({ metadata, api, actionCreators, Form })
